import { Group } from "@iventis/types";
import * as d3 from "d3";

/** If there are 3 levels of venueLocations we can assume we include clusters */
export const includeClustersInGroups = (groups: Group[]): boolean => groups[0]?.subGroups && groups[0]?.subGroups[0]?.subGroups?.length > 0;

export const getContrastTextColour = (bgColour: string): string => {
    const rgb = d3.rgb(d3.color(bgColour));
    // Luminance formula from RGB. Photometric/digital ITU BT.709:
    const luma = 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b;
    return luma > 165 ? "#000" : "#fff";
};
